import React, { useEffect, useRef, useState } from "react";
import { lottieEmoji, notoLottieUrl } from "@/lib/lottieStickers";

const cache = new Map(); // url -> Promise<animationData>

const loadJson = (url) => {
  if (!cache.has(url)) {
    const p = fetch(url).then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
    p.catch(() => cache.delete(url));
    cache.set(url, p);
  }
  return cache.get(url);
};

// Animated Noto emoji for native "lottie:<id>" stickers; falls back to the big emoji.
export const LottieSticker = ({ text, testid }) => {
  const emoji = lottieEmoji(text);
  const box = useRef(null);
  const [failed, setFailed] = useState(!emoji);

  useEffect(() => {
    if (!emoji) return undefined;
    let anim = null;
    let alive = true;
    Promise.all([import("lottie-web/build/player/lottie_light"), loadJson(notoLottieUrl(emoji))])
      .then(([mod, data]) => {
        if (!alive || !box.current) return;
        anim = (mod.default || mod).loadAnimation({ container: box.current, renderer: "svg", loop: true, autoplay: true, animationData: data });
      })
      .catch(() => alive && setFailed(true));
    return () => { alive = false; if (anim) anim.destroy(); };
  }, [emoji]);

  if (failed) {
    return emoji
      ? <span className="text-6xl leading-none" data-testid={testid}>{emoji}</span>
      : <span className="text-sm italic text-[var(--rc-muted)]" data-testid={testid}>Sticker</span>;
  }
  return <div ref={box} className="w-[130px] h-[130px]" data-testid={testid} aria-label={emoji} />;
};

export default LottieSticker;
